import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SearchService } from '@project/core/api/search/search.service';
import { UNI_CONSTANTS } from '@sparro/app/core/config/constants.config';
import { Project } from '@sparro/app/core/models/project.model';
import { environment } from '@sparro/env/environment';
type FOOTER_TYPES = 'disciplines' | 'timestamp' | 'score' | 'none' | 'discipline';
// Last type added as backward compatibility with project + entry connect.
// Will remove when that code is resolved

@Component({
  selector: 'uni-project-card-footer',
  templateUrl: './project-card-footer.component.html',
  styleUrls: ['./project-card-footer.component.scss']
})

export class ProjectCardFooterComponent implements OnInit {
  @Input() project: Project;
  @Input() host: string = UNI_CONSTANTS.HOSTS.PROJECT;
  @Input() footerType: FOOTER_TYPES = 'disciplines';
  @Input() self: boolean = false;
  @Input() featured: boolean = false;

  constructor(
    public router: Router,
    private searchService: SearchService,
  ) { }

  ngOnInit(): void {
    if (this.host === UNI_CONSTANTS.HOSTS.PROFILE && this.self) {
      this.footerType = 'timestamp';
    } else if (this.host === UNI_CONSTANTS.HOSTS.EVALUATION) {
      this.footerType = 'score';
    } else if(this.host === UNI_CONSTANTS.HOSTS.EVALUATION_DASHBOARD) {
      this.footerType = 'none';
    }
  }
  goToTopic(slug: string): string {
    return `${environment.topicUrl}${slug}`;
  }

  goToDiscipline(discipline): void {
    if (this.host === UNI_CONSTANTS.HOSTS.PROFILE) {
      const url = `${environment.projectUrl}search?query=${discipline.name}&timeline=all&order=title&show=all`;
      window.open(url, '_self');
    } else {
      this.searchService.setSearchDiscipline(discipline);
      this.router.navigate(['search']);
    }
  }
}
